import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { useYupFields } from 'hooks/forms/useYupFields'

export type PaymentLinkFormData = {
  walletId: string
  currency: string
  amount: string
  returnUrl: string
  reference: string
  expiryMinutes: string
}

export interface ExpirtyDateValues {
  expiryType: string
  expiryAmount: number
}

export type PaymentLinkFormKeys = keyof PaymentLinkFormData

export const usePaymentLinkSchema = (t: TFunction<'translation', undefined>) => {
  const { getRequiredYupField, getYupField } = useYupFields()

  return yup.object<Record<PaymentLinkFormKeys, yup.AnySchema>>({
    walletId: getRequiredYupField({
      label: t('formFields.wallet'),
    }),
    currency: getRequiredYupField({
      label: t('formFields.displayCurrency'),
    }),
    amount: getRequiredYupField({
      label: t('formFields.paymentAmount'),
    }),
    reference: getRequiredYupField({
      label: t('formFields.uniqueReference'),
    }),
    expiryMinutes: yup
      .number()
      .typeError(t('formFields.required.expiryDateValid'))
      .required(t('formFields.required.expiryDate'))
      .notOneOf([0], t('formFields.required.expiryDateZero')),
    returnUrl: getYupField({
      label: `${t('formFields.returnUrl')} (${t('optional')})`,
    }),
  })
}
